<template>
  <div class="text-center hero">
    <img class="mb-3 app-logo" src="https://www.nextblu.com/img/favicon.png" alt="NextBlu logo" width="120" />
    <h1 class="mb-4">me</h1>
    <p class="lead">
      The lightning fast method to interact with NextBlu.
    </p>
  </div>
</template>

<script>
export default {
  name: "Hero"
};
</script>

<style scoped>

</style>
